/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Puslapis nerastas",
  "ComingSoon": "Netrukus",
  "YesanPersonalFinance": "Yesan, Asmeniniai finansai",
  "Yesan": "Yesan",
  "PersonalFinance": "Asmeniniai finansai",
  "YesanDownload": "Yesan Parsisiųsti",
  "ThisWebsiteUsesCookies": "Slapukus naudojame rinkdami ir analizuodami informaciją apie mūsų svetainės veikimą ir naudojimą bei teikdami socialinės žiniasklaidos funkcijas. Tęsdami veiklą, jūs sutinkate su mūsų",
  "IGotIt": "GERAI",
  "BecomeFinanciallyFree": "Tapkite finansiškai laisvi",
  "inStepsAndActions": "8 žingsniais ir 3 veiksmais.",
  "TrackPlanAnalyze": "Sekite. Planuokite. Analizuokite.",
  "FTrack": "1. Stebėti",
  "FPlan": "2. Planuokite",
  "FAnalyze": "3. Analizuoti",
  "Features": "Funkcijos",
  "FeaturesSubHeading": "Grynai pradedantiesiems, jau turintiems finansinį raštingumą, tai programa, kurios jums reikia, kad taptumėte finansiškai laisvi.",
  "ManageAccounts": "Tvarkykite sąskaitas",
  "CashLiquidFixedAssetsLiabilities": "Pinigų, likvidžiųjų lėšų, ilgalaikio turto ir įsipareigojimų.",
  "TrackTransactions": "Stebėkite sandorius",
  "IncomesExpensesTransferInvestments": "Įplaukos, išlaidos, pervedimai, investicijos.",
  "ImportExport": "Importuoti / eksportuoti",
  "YourDataAlwaysAccessible": "Jūsų duomenys visada pasiekiami.",
  "PlanYourFreedom": "Planuokite savo laisvę",
  "StepsAwayFromFI": "8 žingsniai iki finansinės nepriklausomybės.",
  "BudgetsAndGoals": "Biudžetai ir tikslai",
  "CheckYourProgressAndAchieve": "Tikrinkite savo pažangą ir siekite finansinių tikslų.",
  "DashboardAndAnalytics": "Prietaisų skydelis ir analizė",
  "ReviewLearnOptimizeWith": "Peržiūrėkite, mokykitės, optimizuokite naudodami diagramas, įžvalgas ir įrankius.",
  "Security": "Saugumas",
  "MilitaryGradeEncryption": "Karinio lygio šifravimas, biometrijos palaikymas, duomenys saugomi jūsų įrenginiuose.",
  "OfflineMode": "Neprisijungus prie interneto",
  "YourDataAlwaysAccessibleAndModif": "Jūsų duomenys visada prieinami ir keičiami.",
  "Track": "Sekite",
  "Income": "Pajamos",
  "Expense": "Išlaidos",
  "Transfer": "Perkelkite",
  "transactionsAndManageAccounts": "sandorius ir tvarkykite įvairias sąskaitas:",
  "checkings": "Patikrinkite",
  "savings": "Taupomosios sąskaitos",
  "realEstate": "Nekilnojamasis turtas",
  "stocks": "Akcijų rinkos",
  "bonds": "Obligacijos",
  "crypto": "Kriptovaliutos",
  "notes": "Vekseliai, grynieji pinigai Piniginė",
  "envelopes": "Vokai",
  "privateEquity": "Privatus kapitalas",
  "metal": "Metalas",
  "retirement": "Pensija",
  "lifeInsurance": "Gyvybės draudimas",
  "intellectualProperty": "Intelektinė nuosavybė",
  "otherLiquidAsset": "Kitas likvidus turtas",
  "otherFixedAsset": "Kitas ilgalaikis turtas",
  "mortgage": "Hipoteka",
  "loan": "Vartojimo paskola",
  "creditCard": "Kredito kortelė",
  "otherLiability": "Kiti įsipareigojimai",
  "AccountsManagement": "Sąskaitų valdymas",
  "MultipleAccountsTypesAndGrouping": "Kelių tipų sąskaitos ir jų grupavimas",
  "LinkAccounts": "Susieti sąskaitas iš savo institucijų (galima tik tam tikrose šalyse)",
  "SmartAccounts": "Išmaniosios sąskaitos",
  "AddEditDeleteTransactions": "Pridėti / redaguoti / ištrinti operacijas",
  "TickVerifiedTransactions": "Pažymėti patikrintas operacijas",
  "CategorizeTransactions": "Kategorizuoti sandorius",
  "TagTransactions": "Žymėti sandorius",
  "TrackKakeiboType": "Stebėti \"Kakeibo\" tipą",
  "TrackInvestments": "Stebėti investicijas (galima tik tam tikrose šalyse)",
  "ImportFromCSVFile": "Importuoti visus arba palaipsniui sandorius iš CSV failo",
  "ExportToCSVFile": "Eksportuoti operacijas į CSV failą",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 žingsniai link finansinės nepriklausomybės plano, detalus biudžeto planavimas, greičiau pasiekite savo finansinius tikslus.",
  "levelsTowardsFI": "8 pakopos link finansinės nepriklausomybės",
  "EstablishBudgetsPer": "Sudarykite biudžetus pagal",
  "account": "sąskaitą",
  "accountType": "sąskaitos tipas",
  "KakeiboType": "Kakeibo tipas",
  "category": "kategorija",
  "tag": "žyma",
  "label": "etiketė",
  "TrackBudgetsPerFrequency": "Stebėti biudžetus pagal dažnį",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Sukurkite tikslus, susijusius su išlaidomis, balansu, pinigų srautais, veiksmais",
  "TrackGoalsProgress": "Stebėti tikslų pažangą",
  "ReviewLearnOptimizeWithReportsCharts": "Peržiūrėkite, mokykitės, optimizuokite naudodami ataskaitas, diagramas, tendencijas, įžvalgas, įrankius.",
  "Dashboard": "Prietaisų skydelis",
  "FSNetWorth": "Finansinės ataskaitos: Grynoji vertė",
  "FSPnL": "Finansinės ataskaitos: Pelno (nuostolių) ataskaita: Pajamų ataskaita / Pelno (nuostolių) ataskaita",
  "FSBalanceSheetAssetsLiabilities": "Finansinės ataskaitos: Finansinės ataskaitos: balansas, turtas, įsipareigojimai",
  "FSCashFlow": "Finansinės ataskaitos: Pinigų srautų ataskaita, debetas, kreditas, srautai",
  "FSFlows": "Finansinės ataskaitos: Srautai",
  "FSRatios": "Finansinės ataskaitos: Santykiai",
  "TrendsMonthEnd": "Mėnesio pabaigos tendencijos: Įplaukos ir išlaidos, pinigų srautai",
  "TrendsPerformance": "Veiklos rezultatų tendencijos: Metinė, Mėnesinė, WoW",
  "IncomeTrendsPer": "Pajamų tendencijos per",
  "SpendingTrendsPer": "Išlaidų tendencijos vienam asmeniui",
  "RecurringItemsIE": "Pasikartojantys straipsniai: Pajamos ir išlaidos",
  "DebtProgressTrends": "Skolos progreso tendencijos",
  "KakeiboMTDReviewTrends": "Kokie yra tendencijos: MTD apžvalga, paskutinis mėnuo, tendencijos",
  "FIWCLE": "Finansinė nepriklausomybė: Sieninė diagrama, išlaidos pagal gyvenimo energiją",
  "DebtPaydownSnowballAvalanche": "Skolos grąžinimas: Sniego gniūžtė, lavina",
  "FullyCustomizableAnalyticsRange": "Visiškai pritaikomas analizės laiko intervalas",
  "ContactUs": "Susisiekite su mumis",
  "Privacy": "Privatumas",
  "Terms": "Terminai",
  "About": "Apie",
  "IAgreeToThe": "Sutinku su",
  "AndThe": "ir",
  "PrivacyPolicy": "Privatumo politika",
  "TermsOfUse": "Naudojimo sąlygos",

  "DigitalSoftwareExperienceTagline": "Skaitmeninės programinės įrangos patirtis šiuolaikiniame pasaulyje",
  "DigitalExperience": "Skaitmeninė patirtis",
  "SoftwareForTheModernWorld": "Šiuolaikiniam pasauliui skirta programinė įranga",
  "MobileApplications": "Mobiliosios programos",
  "forConnectedAndOfflineHumans": "prisijungusiems ir neprisijungusiems žmonėms",
  "CloudSaaS": "Debesų SaaS",
  "ResponsiveAndWebServices": "Atsparios ir žiniatinklio paslaugos",
  "PersonalFinanceServices": "Asmeninių finansų paslaugos",
  "YS_p1": "\"Yesan\" yra dinamiška programinės įrangos bendrovė, kuri specializuojasi kuriant pažangiausias vartotojams pritaikytas mobiliąsias programėles. Puikiai suprasdama besikeičiančius šiuolaikinių technologiškai išprususių vartotojų poreikius ir pageidavimus, \"Yesan\" siekia kurti intuityvią, patrauklią ir daug funkcijų turinčią mobiliąją patirtį, kuri praturtina vartotojų gyvenimą.",
  "YS_p2": "\"Yesan\" misijos pagrindas - nepaliaujamas įsipareigojimas diegti naujoves ir kūrybiškumą; kiekvienas produktas kruopščiai kuriamas taip, kad užtikrintų vientisą funkcionalumą ir išskirtinę naudotojo patirtį.",
  "PersonalFinanceApplication": "Asmeninių finansų programa",
  "YPF_p1": "Yesan, Personal Finance - tai moderni asmeninių finansų mobilioji programa, sukurta siekiant suteikti naudotojams išsamias finansų valdymo priemones, patogiai pasiekiamas ranka. Elegantiška ir intuityvi sąsaja \"Yesan, Personal Finance\" siūlo holistinį požiūrį į finansų valdymą, pritaikytą visų lygių finansinio raštingumo vartotojams.",
  "YPF_p2": "Pagrindinės funkcijos apima biudžeto stebėjimą, išlaidų kategorizavimą ir operacijų stebėjimą realiuoju laiku, todėl naudotojai gali be vargo susipažinti su savo išlaidų įpročiais. Programoje taip pat siūlomos pritaikomos biudžeto sudarymo parinktys, leidžiančios naudotojams nustatyti finansinius tikslus ir stebėti savo pažangą laikui bėgant.",
  "YPF_p3": "Be to, \"Yesan, Personal Finance\" pirmenybė teikiama saugumui, nes joje naudojami pažangiausi šifravimo protokolai, kad būtų apsaugota slapta naudotojų finansinė informacija. Naudodami banko lygio saugumo priemones, naudotojai gali drąsiai susieti savo sąskaitas ir sinchronizuoti operacijas nepažeisdami privatumo.",
  "YPF_p4": "\"Yesan, Personal Finance\" neapsiriboja tik pagrindiniu biudžeto sudarymu, bet siūlo įžvalgią analizę ir asmenines rekomendacijas finansiniams sprendimams optimizuoti. Nesvarbu, ar tai būtų potencialių taupymo galimybių nustatymas, investicinių portfelių stebėjimas, ar skolų grąžinimo strategijų valdymas, programėlė pateikia pritaikytas įžvalgas, padedančias naudotojams pasiekti jų finansinius tikslus.",
  "Discover": "Atraskite",

  "Firstname": "Vardas ir pavardė",
  "Lastname": "Pavardė",
  "Company":"Įmonė",
  "Subject": "Tema",
  "Email": "El. paštas",
  "Message": "Žinutė",
  "ThankYouForContactingUs": "Dėkojame, kad susisiekėte su mumis",
  "ValidFirstnameRequired": "Būtina nurodyti galiojantį vardą.",
  "ValidLastnameRequired": "Būtina nurodyti galiojančią pavardę.",
  "ValidEmailAddressRequired": "Įveskite galiojantį el. pašto adresą.",
  "ValidSubjectRequired": "Prašome pasirinkti galiojančią temą.",
  "ValidMessageRequired": "Prašome įvesti galiojančią žinutę.",
  "UnableToSendTheFormPleaseRetryLater": "Nepavyksta išsiųsti formos, prašome pakartoti vėliau.",
  "Information": "Informacija",
  "Sales":"Pardavimai",
  "Support": "Parama",
  "Press": "Spauskite",
  "Partnership": "Partnerystė",
  "Other": "Kiti",
  "Blog":"Tinklaraštis",

  "Accept":"Priimti",
  "Decline":"Atsisakyti",

  "WorklogCalendar":"Jira darbo kalendorius",

  "DirectlyAccessibleInProjectApps":"Tiesiogiai pasiekiami projekto programėlėse",
  "VisualizeWhereYouSpentYourTime":"Vizualizuokite, kur praleidote savo laiką",
  "AllYourWorklogsInACalendar":"Visi jūsų darbo žurnalai kalendoriuje",
  "MonthSummary":"Mėnesio suvestinė",
  "CheckIfYouForgotToLogTime":"Patikrinkite, ar nepamiršote užregistruoti laiko.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Tiesiogiai pasiekite klausimus ir atnaujinkite laiką",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Spustelėkite darbo žurnalo elementą, kad tiesiogiai pasiektumėte klausimus ir redaguotumėte stebimą laiką",
  "AlsoAvailableInDarkMode":"Taip pat galima naudoti tamsiuoju režimu",
  "DirectlyLogWorkOnTheCalendarVisually":"Tiesiogiai registruokite darbus kalendoriuje vizualiai",
  "ClickOnTheCalendarToCreateNewWorklog":"Spustelėkite ant kalendoriaus, kad sukurtumėte naują darbo žurnalą",

  "AppsForAtlassian":"Atlassian programos",
  "YCL_p1":"Vizualizuokite visus savo darbo žurnalus kalendoriuje su mėnesio, savaitės, darbo savaitės, dienos vaizdais.",
  "YCL_p2":"Registruokite darbus tiesiai iš kalendoriaus vizualiai pasirinkdami laiko intervalą.",
  "YCL_p3":"Nustatykite, jei pamiršote sekti darbo laiko apskaitos žiniaraščius.",
  "YCL_p4":"Prieinama jūsų kalba: (UK), anglų (UK), kinų (supaprastinta), kinų (tradicinė), čekų, danų, estų, suomių, prancūzų, vokiečių, islandų, islandų, italų, japonų, korėjiečių, norvegų, lenkų, portugalų (Brazilija), portugalų (Portugalija), olandų, rusų, suomių, vengrų, švedų, turkų.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finansinis portfelis Jira sistemai",
  "BringRealFinancialPortfolio":"Įdiekite tikrą finansinio portfelio valdymą Jira sistemoje. Vienoje vietoje stebėkite biudžetus, kapitalines ir veiklos išlaidas bei projektų sąnaudas.",
  "YFPAboutQ":"Kiek iš tikrųjų mums kainuoja Jira projektai?",
  "YFPAbout":"Finansinis portfelis Jira\nFinansų vadovai ir PMO sunkiai atsako į paprastą klausimą:\nKiek iš tikrųjų mums kainuoja mūsų Jira projektai?\nJira stebi darbą.\nFinansų skyrius stebi biudžetus.\nŠi programa pagaliau sujungia šiuos du dalykus.\n\nFinansinis portfelis paverčia Jira lengva PPM + finansinio planavimo platforma — be brangių įmonės įrankių.",
  "YFPPorfolioQ":"Portfelio biudžetai ir stebėjimas",
  "YFPPorfolioP":"Sukurkite portfelius iš kelių Jira projektų ir apibrėžkite: biudžeto sumą, valiutą, datų intervalą, įtrauktus projektus, komandas. Automatiškai stebėkite faktines išlaidas, kai darbas vyksta Jira.",
  "YFPPorfolioListQ":"Portfeliai",
  "YFPPorfolioListP":"Sukurkite finansinius portfelius, apimančius kelis Jira projektus, ir iš karto matykite: biudžetą ir faktines išlaidas, projekto išlaidų tempą realiuoju laiku, kapitalo išlaidų (CapEx) ir veiklos išlaidų (OpEx) paskirstymą, išlaidas vienam uždaviniui ir projektui, eksportuojamas finansines ataskaitas. Viskas tiesiogiai remiasi Jira darbo žurnalais.",
  "CostQ":"Automatinis išlaidų skaičiavimas",
  "CostP":"Paversti laiko sekimą realiais finansiniais duomenimis. Programa: skaito Jira darbo žurnalus, taiko valandinius tarifus, kasdien skaičiuoja realias projekto išlaidas. Be skaičiuoklių. Be rankinio darbo.",
  "RatesQ":"Tarifai",
  "RatesP":"Nustatykite valandinius tarifus pagal projektą, komandą ar bendrai",
  "ReportQ":"CSV finansinės ataskaitos",
  "ReportP":"Eksportuokite portfelio finansinius duomenis per kelias sekundes. Puikiai tinka: finansų komandoms, finansų direktorių ataskaitoms, biudžeto planavimui, audito paramai",
  "SettingsQ": "CapEx ir OpEx klasifikacija",
  "SettingsP": "Atitinka apskaitos ir audito reikalavimus. Klasifikuokite darbą į: kapitalizuojamą plėtrą (CapEx) ir operacinį darbą (OpEx). Sukurkite eksportuojamas ataskaitas, parengtas finansų komandoms."
};

export const documents = {
};
